import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class ProductId extends Component {
  render() {
    const { id } = this.props;
    return (
      <FormattedMessage
        id="product.idLabel"
        defaultMessage="Product Code: {id}"
        values={{
          id: <span>{id}</span>
        }}
      />
    );
  }
}

ProductId.propTypes = {
  id: PropTypes.string.isRequired
};

export default ProductId;



// WEBPACK FOOTER //
// ./src/components/product/ProductId/index.jsx